import { useContext, useMemo } from 'react';
import ItemCategories from '../../../ui-components/Categories';
import { bookingState } from '../client-state/booking-state-context';
import {
  allCategoryId,
  selecetedItemCategoryActionTypes,
} from '../../../redusers/selected-item-category-reducer';
import useBookingShop from '../server-data/use-booking-shop';
import useBookingTracking from 'Hooks/useBookingTracking';
import useTypeSafeLocalize from 'Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from 'localizations/types';
import { getItemCategoryId } from 'Utils/items';

export interface ItemCategory {
  id: string;
  name: string;
  order: number;
}

const ItemCategoriesWithData = () => {
  const { data: shop } = useBookingShop();
  const { state, dispatch } = useContext(bookingState);
  const track = useBookingTracking();
  const localize = useTypeSafeLocalize();

  const itemCategories = useMemo(() => {
    const allCategory = {
      id: allCategoryId,
      name: localize(LocalizationCategory.product, ProductLocalization.all),
      order: 0,
    };

    let itemCategories: ItemCategory[] = [allCategory];

    if (shop?.items) {
      for (const item of shop.items) {
        if (!item.archived && item.categoryNames.length) {
          for (const categoryName of item.categoryNames) {
            const categoryId = getItemCategoryId(categoryName);

            const existingCategory = itemCategories.find(
              (category) => category.id === categoryId
            );

            if (existingCategory) {
              existingCategory.order += item.order ?? shop.items.length;
            } else {
              itemCategories.push({
                id: categoryId,
                name: categoryName,
                order: item.order ?? shop.items.length,
              });
            }
          }
        }
      }
    }

    return itemCategories.sort((a, b) => a.order - b.order);
  }, [shop?.items, localize]);

  return (
    <ItemCategories
      categories={itemCategories}
      selectedCategoryId={state.selectedItemCategory}
      onChange={(category) => {
        dispatch({
          type: selecetedItemCategoryActionTypes.SELECTED_ITEM_CATEGORY_UPDATE,
          payload: category.id,
        });

        track({ type: 'CHANGE_ITEM_CATEGORY', itemCategory: category.name });
      }}
    />
  );
};

export default ItemCategoriesWithData;
